import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Hero from '../components/home/Hero';
import CollectionShowcase from '../components/home/CollectionShowcase';
import FeaturedProducts from '../components/home/FeaturedProducts';
import BlogSection from '../components/home/BlogSection';
import SEO from '../components/common/SEO';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO 
        url=""
        title="Original Paintings and Fine Art Prints"
        description="Discover original paintings and fine art prints by Swedish artist Gorito. Shop unique artwork including portraits of iconic musicians, meditative kaleidoscopes, and nature-inspired pieces. Worldwide shipping to EU and US."
      />
      <Header />
      <main>
        <Hero />
        <CollectionShowcase />
        <FeaturedProducts />
        <BlogSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
